import React from "react";
import { Button, Flex } from "@chakra-ui/react";
import { useLiveQuery } from "dexie-react-hooks";
import { PageHeader, Search, Tags, Wrapper } from "components";
import { dbQueries, useQueryParams, useAuth, SURGEON_ROLES } from "duck";
import { Protocol, Filters } from "./components";
import { useAddProtocolToCalculations } from "./duck";

const Protocols: React.FC = () => {
  const [params, setParams] = useQueryParams();
  const doctors = params.filter?.doctors?.map((docId: string) => +docId);
  const protocols = useLiveQuery(
    () => dbQueries.getProtocols(params.search, doctors),
    [params]
  );

  const { addProtocol, loading } = useAddProtocolToCalculations();
  const [usedProtocolId, setUsedProtocolId] = React.useState<number>();

  const [{ user }] = useAuth();

  React.useEffect(() => {
    if (SURGEON_ROLES.includes(user.userRole)) {
      setParams(
        {
          ...params,
          filter: { ...params.filter, doctors: [user._id] }
        },
        { replace: true }
      );
    }
  }, [user]);

  return (
    <>
      <PageHeader title="Select Anesthetic Protocols" backURL={-1} />

      <Wrapper mt={6}>
        <Flex direction="column" rowGap={6}>
          <Flex columnGap={4}>
            <Search />
            <Filters />
          </Flex>
          {!!doctors && <Tags withDoctors />}
        </Flex>

        <Flex direction="column" mt={8} rowGap={12}>
          {protocols &&
            protocols
              .filter(
                protocol =>
                  protocol.medicationCalculations?.collection?.length ||
                  protocol.regionalBlocks?.collection?.length
              )
              .map(protocol => (
                <Flex direction="column" rowGap={8} key={protocol._id}>
                  <Button
                    alignSelf="end"
                    onClick={() => {
                      addProtocol(protocol);
                      setUsedProtocolId(protocol._id);
                    }}
                    isLoading={usedProtocolId === protocol._id && loading}
                    isDisabled={usedProtocolId !== protocol._id && loading}
                  >
                    Use Protocol
                  </Button>
                  <Protocol data={protocol} />
                </Flex>
              ))}
        </Flex>
      </Wrapper>
    </>
  );
};

export default Protocols;
